import { useCallback, useState } from "react";

// Pairs with ConfirmDialog to replace the open/target/cancel boilerplate
// that used to be hand-rolled per delete flow (deleteConfirmation + deleteId + cancelDelete).
const useConfirmDialog = () => {
  const [open, setOpen] = useState(false);
  const [target, setTarget] = useState(null);

  const openDialog = useCallback((payload = null) => {
    setTarget(payload);
    setOpen(true);
  }, []);

  const closeDialog = useCallback(() => {
    setOpen(false);
    setTarget(null);
  }, []);

  return { open, target, openDialog, closeDialog };
};

export default useConfirmDialog;
